import { SaleDetailModel } from 'api-hooks/sale/model';
import { guestNameTransformer } from 'legacy-modules/sales/ticket-sale/hooks/use-get-default-values';
import React from 'react';

import {
  FlightRescheduleFormType,
  FlightSaleAddOnsType,
  FlightSaleGuestType,
  FlightSaleType,
} from '../form-type';

interface Props {
  flightSale: SaleDetailModel;
}

export default function useGetDefaultValues(props: Props) {
  const { flightSale } = props;

  const defaultValues = React.useMemo<FlightRescheduleFormType>(() => {
    const flightSales: FlightSaleType[] = (flightSale?.flightSales || []).map(
      (flight) => {
        //Add Ons
        const flightSaleAddOns: FlightSaleAddOnsType[] =
          flight.flightSaleAddOns.map((addons) => ({
            isSelected: false,
            description: addons.description || '',
            id: addons.id,
            route: addons.route,
            price: addons.price,
            guestId: addons.guest.id,
            guestName: guestNameTransformer(addons.guest),
          }));
        //Guests
        const flightSaleGuests: FlightSaleGuestType[] = flight.flightSaleGuests
          .map((fsg) => ({
            isSelected: false,
            ticket: fsg.ticket,
            preferences: [],
            airlineId: fsg.airline.id,
            preferenceId: fsg.preference?.id,
            date: fsg.date,
            detail: fsg.detail,
            route: fsg.route,
            time: fsg.time,
            id: fsg.id,
            guestId: fsg.guest.id,
            guestName: guestNameTransformer(fsg.guest),
            price: 0,
            tempPrice: fsg.price,
            checkInStatus: fsg.checkInStatus,
          }))
          .flat();

        return {
          isSelected: false,
          id: flight.id,
          bookingCode: flight.bookingCode,
          flightSaleAddOns,
          flightSaleGuests,
        };
      },
    );
    return {
      transactionAt: new Date(),
      total: 0,
      invoiceNumber: flightSale.invoiceNumber,
      customer: [
        flightSale.customer.name,
        flightSale.customer.alias,
        flightSale.customer.phone,
      ]
        .filter((val) => !!val)
        .join(' - '),
      flightSales,
    };
  }, [flightSale]);

  return defaultValues;
}
